export const TRANSLATION_EVENT_NAMES = {
  INITIATED: 'Initiated Translation',
  TRANSLATED: 'Translated Text',
  DISMISSED: 'Dismissed Translation',
}
